import { FetchResult } from 'src/types/TApiQueries';
import { OnboardingProgress, OnboardingProgressUpdateRequest, UserPreferences, UserPreferencesUpdateRequest } from 'src/types/TOnboarding';
import { config } from 'src/utils/config';
import { getStandardHeaders, performFetchWithLogging } from '../utils/helpers';

export function getOnboardingProgress(accessToken: string): Promise<FetchResult<OnboardingProgress>> {
  return performFetchWithLogging(`${config.hostUrl}/api/v1/user/onboarding-progress`, {
    method: 'GET',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
  });
}

export function updateOnboardingProgress(
  data: OnboardingProgressUpdateRequest,
  accessToken: string,
): Promise<FetchResult<OnboardingProgress>> {
  return performFetchWithLogging(`${config.hostUrl}/api/v1/user/onboarding-progress`, {
    method: 'PATCH',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
    body: JSON.stringify(data),
  });
}

export function updateUserPreferences(
  data: UserPreferencesUpdateRequest,
  accessToken: string,
): Promise<FetchResult<UserPreferences>> {
  return performFetchWithLogging(`${config.hostUrl}/api/v1/user/preferences`, {
    method: 'PATCH',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
    body: JSON.stringify(data),
  });
}

export type LoadDemoSamplesRequest = {
  industry?: string;
};

export type LoadDemoSamplesResponse = {
  status: 'OK' | 'ERROR';
  data: {
    assets_loaded: number;
    schema_applied: string;
    tag: string;
  };
};

export function loadDemoSamples(
  data: LoadDemoSamplesRequest,
  accessToken: string,
): Promise<FetchResult<LoadDemoSamplesResponse>> {
  return performFetchWithLogging(`${config.hostUrl}/api/v1/demo/load-samples`, {
    method: 'POST',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
    body: JSON.stringify(data),
  });
}
